'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _errors = require('../configs/errors');

var constant = _interopRequireWildcard(_errors);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @since 2016-06-05 11:40
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author vivaxy
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var FetchError = function (_Error) {
    _inherits(FetchError, _Error);

    function FetchError(response) {
        _classCallCheck(this, FetchError);

        var _this = _possibleConstructorReturn(this, (FetchError.__proto__ || Object.getPrototypeOf(FetchError)).call(this, response.statusText));

        _this.response = response;
        _this.name = constant.FETCH;
        return _this;
    }

    return FetchError;
}(Error);

exports.default = FetchError;


//////////////////
// WEBPACK FOOTER
// ./~/@dp/cmp-prototype-lib/errors/FetchError.js
// module id = 222
// module chunks = 0